import React from "react";
import { Overlay, ModalContainer, CloseButton } from "./ModalStyles"; // Importando os estilos
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ open, onClose, title, children, icon, actions}) => {

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {icon && <IconButton size="small" sx={{ mr: 1 }}>{icon}</IconButton>}
          {title}
        </span>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        {actions || (
          <Button onClick={onClose} color="primary">
            Fechar
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default Modal;
